import React from "react";
import { Box, Theme, makeStyles } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { Price } from "./Price";

export interface PricesProps {
  monthlyPrice: number;
  upFrontPrice: number;
}

export const Prices = ({ monthlyPrice, upFrontPrice }: PricesProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.prices}>
      <Price label="Per Month" price={monthlyPrice} />
      <AddIcon className={classes.plus} />
      <Price label="Up Front" price={upFrontPrice} />
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  prices: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1.625)
  },
  plus: {
    color: "#7A5AFF",
    margin: "0 5px"
  }
}));
